<template>
  <v-container fluid>
    <v-card-title>
      Panier
    </v-card-title>
    <v-card>

        <v-card-text>
      <ShoppingCartItem
          v-for="item in items"
          :item="item"
          :key="item.id"/>
          <v-divider class="border-opacity-50" color="black"></v-divider>
      <ShoppingCartSummary/>
          <v-divider  :thickness="8" class="border-opacity-100" color="#01579B"></v-divider>
      <div class="mt-3 text-center">
        <v-btn class="mb-2" color="primary"
               :disabled="orderOnLimit"
               @click="buy">
          Checkout
        </v-btn>

        <p v-if="orderOnLimit">Order is over limit.</p>
      </div>
        </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import ShoppingCartItem from './ShoppingCartItem'
import ShoppingCartSummary from './ShoppingCartSummary'
import {mapGetters} from 'vuex'

export default {
  name: 'ShoppingCart',
  computed: mapGetters({
    items: 'cartProducts',
    orderOnLimit: 'orderOnLimit'
  }),
  components: {
    ShoppingCartItem,
    ShoppingCartSummary
  },
  methods: {
    buy() {
      window.alert("You've bought it :)")
      window.location.reload()
    }
  }
}
</script>
